<template>
  <div class="expire-info-tray">
    <div class="alert-icon-tray">
      <el-popover
        placement="bottom-end"
        effect="dark"
        width="348"
        trigger="click"
        @show="alertShowHandle"
        style="cursor: pointer;">
        <template #reference>
          <el-badge :hidden="countAll<=0" :value="countAll" class="item">
            <i class="el-icon-message-solid alert-icon"/>
          </el-badge>
        </template>
        <template #default>
          <el-row>
            <el-col :span="12" style="font-size: 18px; font-weight: bold; color: blue;">待办事项</el-col>
            <el-col :span="12">
              <!--<el-select style="width:100px;margin-left:70px;" size="mini" v-model="reportYear" @change="reportYearChangeHandle()">
                <el-option v-for="item in reportYearList" :key="item" :label="item" :value="item"/>
              </el-select>-->
            </el-col>
          </el-row><br/>
          <el-row v-if="projectTodoList.length > 0">
            <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">项目台账</el-col>
          </el-row>
          <div style="margin-bottom:15px;" v-if="projectTodoList.length > 0">
            <el-row v-for="(item, index) in projectTodoList" :key="index">
              <el-col :span="15">
                <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
              </el-col>
              <el-col :span="3">
                <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                  <span v-else>{{ item.dispNum }}</span>
                </el-button>
                <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span style="text-decoration: underline;">详细</span>
                </el-button>
              </el-col>
              <el-col :span="3">
                <span>件</span>
              </el-col>
              <el-col :span="3">
                <el-switch
                  v-model="item.warnSwitch"
                  :active-value="1"
                  active-color="#13ce66"
                  @change="updWarnSwitch(item)"
                  :inactive-value="0"/>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="archiveTodoList.length > 0">
            <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">项目归档</el-col>
          </el-row>
          <div style="margin-bottom:15px;" v-if="archiveTodoList.length > 0">
            <el-row v-for="(item, index) in archiveTodoList" :key="index">
              <el-col :span="15">
                <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
              </el-col>
              <el-col :span="3">
                <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                  <span v-else>{{ item.dispNum }}</span>
                </el-button>
                <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span style="text-decoration: underline;">详细</span>
                </el-button>
              </el-col>
              <el-col :span="3">
                <span>件</span>
              </el-col>
              <el-col :span="3">
                <el-switch
                  v-model="item.warnSwitch"
                  :active-value="1"
                  active-color="#13ce66"
                  @change="updWarnSwitch(item)"
                  :inactive-value="0"/>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="projectAuditTodoList.length > 0">
            <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">项目审核</el-col>
          </el-row>
          <div style="margin-bottom:15px;" v-if="projectAuditTodoList.length > 0">
            <el-row v-for="(item, index) in projectAuditTodoList" :key="index">
              <el-col :span="15">
                <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
              </el-col>
              <el-col :span="3">
                <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                  <span v-else>{{ item.dispNum }}</span>
                </el-button>
                <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span style="text-decoration: underline;">详细</span>
                </el-button>
              </el-col>
              <el-col :span="3">
                <span>件</span>
              </el-col>
              <el-col :span="3">
                <el-switch
                  v-model="item.warnSwitch"
                  :active-value="1"
                  active-color="#13ce66"
                  @change="updWarnSwitch(item)"
                  :inactive-value="0"/>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="projectReviewTodoList.length > 0">
            <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">项目复核</el-col>
          </el-row>
          <div style="margin-bottom:15px;" v-if="projectReviewTodoList.length > 0">
            <el-row v-for="(item, index) in projectReviewTodoList" :key="index">
              <el-col :span="15">
                <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
              </el-col>
              <el-col :span="3">
                <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                  <span v-else>{{ item.dispNum }}</span>
                </el-button>
                <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span style="text-decoration: underline;">详细</span>
                </el-button>
              </el-col>
              <el-col :span="3">
                <span>件</span>
              </el-col>
              <el-col :span="3">
                <el-switch
                  v-model="item.warnSwitch"
                  :active-value="1"
                  active-color="#13ce66"
                  @change="updWarnSwitch(item)"
                  :inactive-value="0"/>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="projectSignTodoList.length > 0">
            <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">项目签发</el-col>
          </el-row>
          <div style="margin-bottom:15px;" v-if="projectSignTodoList.length > 0">
            <el-row v-for="(item, index) in projectSignTodoList" :key="index">
              <el-col :span="15">
                <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
              </el-col>
              <el-col :span="3">
                <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                  <span v-else>{{ item.dispNum }}</span>
                </el-button>
                <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span style="text-decoration: underline;">详细</span>
                </el-button>
              </el-col>
              <el-col :span="3">
                <span>件</span>
              </el-col>
              <el-col :span="3">
                <el-switch
                  v-model="item.warnSwitch"
                  :active-value="1"
                  active-color="#13ce66"
                  @change="updWarnSwitch(item)"
                  :inactive-value="0"/>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="projectPrintTodoList.length > 0">
            <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">项目文印</el-col>
          </el-row>
          <div style="margin-bottom:15px;" v-if="projectPrintTodoList.length > 0">
            <el-row v-for="(item, index) in projectPrintTodoList" :key="index">
              <el-col :span="15">
                <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
              </el-col>
              <el-col :span="3">
                <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                  <span v-else>{{ item.dispNum }}</span>
                </el-button>
                <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span style="text-decoration: underline;">详细</span>
                </el-button>
              </el-col>
              <el-col :span="3">
                <span>件</span>
              </el-col>
              <el-col :span="3">
                <el-switch
                  v-model="item.warnSwitch"
                  :active-value="1"
                  active-color="#13ce66"
                  @change="updWarnSwitch(item)"
                  :inactive-value="0"/>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="billTodoList.length > 0">
            <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">发票中心</el-col>
          </el-row>
          <div style="margin-bottom:15px;" v-if="billTodoList.length > 0">
            <el-row v-for="(item, index) in billTodoList" :key="index">
              <el-col :span="15">
                <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
              </el-col>
              <el-col :span="3">
                <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                  <span v-else>{{ item.dispNum }}</span>
                </el-button>
                <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span style="text-decoration: underline;">详细</span>
                </el-button>
              </el-col>
              <el-col :span="3">
                <span>件</span>
              </el-col>
              <el-col :span="3">
                <el-switch
                  v-model="item.warnSwitch"
                  :active-value="1"
                  active-color="#13ce66"
                  @change="updWarnSwitch(item)"
                  :inactive-value="0"/>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="collectTodoList.length > 0">
            <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">财务管理</el-col>
          </el-row>
          <div style="margin-bottom:15px;" v-if="collectTodoList.length > 0">
            <el-row v-for="(item, index) in collectTodoList" :key="index">
              <el-col :span="15">
                <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
              </el-col>
              <el-col :span="3">
                <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                  <span v-else>{{ item.dispNum }}</span>
                </el-button>
                <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span style="text-decoration: underline;">详细</span>
                </el-button>
              </el-col>
              <el-col :span="3">
                <span>件</span>
              </el-col>
              <el-col :span="3">
                <el-switch
                  v-model="item.warnSwitch"
                  :active-value="1"
                  active-color="#13ce66"
                  @change="updWarnSwitch(item)"
                  :inactive-value="0"/>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="otherTodoList.length > 0">
            <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">其他</el-col>
          </el-row>
          <div style="margin-bottom:15px;" v-if="otherTodoList.length > 0">
            <el-row v-for="(item, index) in otherTodoList" :key="index">
              <el-col :span="15">
                <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
              </el-col>
              <el-col :span="3">
                <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                  <span v-else>{{ item.dispNum }}</span>
                </el-button>
                <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                  <span style="text-decoration: underline;">详细</span>
                </el-button>
              </el-col>
              <el-col :span="3">
                <span>件</span>
              </el-col>
              <el-col :span="3">
                <el-switch
                  v-model="item.warnSwitch"
                  :active-value="1"
                  active-color="#13ce66"
                  @change="updWarnSwitch(item)"
                  :inactive-value="0"/>
              </el-col>
            </el-row>
          </div>
        </template>
      </el-popover>
    </div>
    <div v-if="dialogVisible">
    <el-dialog :close-on-click-modal="false" destroy-on-close 
    		:append-to-body="true" style="color: #409EFF"
    		:visible.sync="dialogVisible" width="400px" title="待办事项">
      <template #default>
        <expire-info-tray-for-alert :reportYear="reportYear" :todoList="todoList" @close-dialog="dialogVisible=false"/>
      </template>
      <template #footer/>
    </el-dialog>
    </div>
    <div v-if="dialogVisibleReport">
      <el-dialog :close-on-click-modal="false" destroy-on-close :append-to-body="true"
                 :visible.sync="dialogVisibleReport" width="990px" title="CPA年度审计报告数">
        <template #default>
          <report-analysis-table :report-year="reportYear" :report-year-list="reportYearList" @close-dialog="closeDialogReport"/>
        </template>
        <template #footer/>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ExpireInfoTrayForAlert from "@/components/common/ExpireInfoTrayForAlert";
import ReportAnalysisTable from '@/components/manage/portal/ReportAnalysisTable';
import moment from "moment";
export default {
  name: 'ExpireInfoTray',
  components: {
  	ExpireInfoTrayForAlert,
  	ReportAnalysisTable
  },
  data() {
    return {
      reportYearList: [],
      reportYear: this.$moment().format('YYYY'),
      todoList: [],
      dialogVisibleReport: false,
      dialogVisible: false
    }
  },
  computed: {
    countAll() {
      let num = 0;
      if (this.todoList && this.todoList.length > 0) {
        this.todoList.forEach(x => num = num + x.dispNum)
      }
      return num;
    },
    projectTodoList() {
      return this.todoList.filter(x => x.todoType == 'project')
    },
    archiveTodoList() {
      return this.todoList.filter(x => x.todoType == 'project-archive')
    },
    projectAuditTodoList() {
      return this.todoList.filter(x => x.todoType == 'project-audit')
    },
    projectReviewTodoList() {
      return this.todoList.filter(x => x.todoType == 'project-review')
    },
    projectSignTodoList() {
      return this.todoList.filter(x => x.todoType == 'project-sign')
    },
    projectPrintTodoList() {
      return this.todoList.filter(x => x.todoType == 'project-print')
    },
    billTodoList() {
      return this.todoList.filter(x => x.todoType == 'bill')
    },
    collectTodoList() {
      return this.todoList.filter(x => x.todoType == 'collect')
    },
    otherTodoList() {
      return this.todoList.filter(x => x.todoType == 'other')
    }
  },
  methods: {
    async getReportYearList() {
      let {data} = await this.axios.get("project/getReportYearList", {params: {reportYear: this.reportYear}})
      this.reportYearList = data.retResult;
    },
    reportYearChangeHandle() {
      this.getTodoList();
      this.getData()
    },
    async getTodoList() {
      //let {data} = await this.axios.get("platform/init", {params: {reportYear: this.reportYear}})
      let {data} = await this.axios.get("platform/init")
      this.todoList = data.retResult;
    },
    async updWarnSwitch(item) {
      let param = new URLSearchParams();
      param.append("warnField", item.warnField);
      param.append("warnSwitch", item.warnSwitch);
      await this.axios.post("/warnSwitch/updWarnSwitch", param).then(responce => {
        let status = responce.data.retResult
      })
    },
    async handleMsgBtnClick(row) {
      if (row.popupFlg == '0') {
        let queryObj = {}
        if (!_.isNull(row.paramList)) {
          row.paramList.forEach(x => {
            let strArr = x.split("-")
            this.$set(queryObj, strArr[0], strArr[1])
          })
        }
        if (queryObj == {}) {
          await this.$router.push({ name: 'dummy' })
          await this.$router.push({ name: row.componentNm })
        } else {
          await this.$router.push({ name: 'dummy' })
          await this.$router.push({ name: row.componentNm, query: { ...queryObj } })
        }
      } else {
        if (row.popupNm == 'popup2') {
          this.toCpaReportNumPop()
        }
      }
    },
    toCpaReportNumPop() {
      this.dialogVisibleReport = true;
    },
    closeDialogReport() {
      this.dialogVisibleReport = false;
    },
    async alertShowHandle() {
      await this.getTodoList();
      await this.getData()
    },
    async getData() {
      let lst = this.todoList.filter(x => x.warnSwitch == 1)
      let countFg1 = lst.length > 0
      let num = 0;
      lst.forEach(x => num = num + x.dispNum)
      let countFg2 = num > 0;
      if (countFg1 && countFg2 && this.$store.state.showAlerFg == '') {
        this.$store.commit('saveShowAlerFg', '1')
        this.dialogVisible = true
      } else {
        this.dialogVisible = false
      }
    }
  },
  async mounted() {
    await this.getReportYearList();
    await this.getTodoList();
    await this.getData()
  }
}
</script>

<style>
.expire-info-tray .el-button {
  padding: 0;
}

.alert-icon {
  font-size: 35px;
  color: white;
  transition: 0.3s;
}

.alert-icon:hover {
  opacity: .8;
}

.alert-icon-tray {
  margin-right: 25px;
  overflow: visible;
  height: 40px;
  display: inline-block;
}

.alert-icon-tray .el-badge {
  margin-top: 4px;
}

.el-badge sup.el-badge__content.is-fixed {
  top: 5px;
  right: 16px;
}
</style>
